import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Logs


export interface Log {
    id: ID;

    
    internalKey: string;

    
    timberKey: string;

    
    length: number;

    
    diameter: number;

    
    volume: number;

    
    timberTypeId: ID;

    
    classId: ID;

    
    thicknessClassId: ID;

    
    linked: boolean;

    
    barkThickness?: number;

    
    externalKey?: string;

    
    commited: boolean;

    
    storageId: ID;

    
    locationId: ID;

    
    cuttingId: ID;

    
    shipmentId?: ID;

    
    createdAt: Date;

    
    localCreatedAt?: Date;

    
    localUpdatedAt?: Date;

    
    localDeletedAt?: Date;

    
    description?: string;

    
    scopeGroupId: ID;

    }

export interface LogTotalQueryRequest {
    cuttingId?: ID,
    storageId?: ID,
    shipmentId?: ID,
    shipmentDefined?: boolean,
}

export interface LogTotalQueryResult {
    commited: boolean,
    totalCount: number,
    totalVolume: number,
}

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            internalKey?: string,
        
    
    

            timberKey?: string,
        
    
    
lengthFrom?: number,
            lengthTo?: number,
        
    
    
diameterFrom?: number,
            diameterTo?: number,
        
    
    
volumeFrom?: number,
            volumeTo?: number,
        
    
    

            timberTypeId: ID[],
        
    
    

            classId: ID[],
        
    
    

            thicknessClassId: ID[],
        
    
    

            shipmentId?: ID,
        
    
    shipmentIdInclude: boolean,
localCreatedAtFrom?: Date,
            localCreatedAtTo?: Date,
        
    
    localCreatedAtInclude: boolean,



        storageIdRefs?: ID[],
        cuttingIdRefs?: ID[],
        shipmentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateLog {
    
    
    timberKey: string;

    
    length: number;

    
    diameter: number;

    
    
    timberTypeId: ID;

    
    classId: ID;

    
    
    linked: boolean;

    
    barkThickness?: number;

    
    externalKey?: string;

    
    commited: boolean;

    
    storageId: ID;

    
    
    
    shipmentId?: ID;

    
    
    localCreatedAt?: Date;

    
    localUpdatedAt?: Date;

    
    localDeletedAt?: Date;

    
    description?: string;

    
    }


export interface UpdateLog {
    
    
    
    length: number;

    
    diameter: number;

    
    
    timberTypeId: ID;

    
    classId: ID;

    
    
    linked: boolean;

    
    barkThickness?: number;

    
    externalKey?: string;

    
    commited: boolean;

    
    
    
    
    shipmentId?: ID;

    
    
    
    localUpdatedAt?: Date;

    
    localDeletedAt?: Date;

    
    description?: string;

    
    }

export interface PresentationLogRequest {
    list: ListRequest,
    filter: {
        timberKey: string,
        timberKeyOr: boolean,
        externalKey: string,
        externalKeyOr: boolean,
        internalKey: string,
        internalKeyOr: boolean,
        storageIdRefs?: ID[],
        cuttingIdRefs?: ID[],
        shipmentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryLog {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Log): PrimaryLog | undefined {
        return entity ? new PrimaryLog(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryLog {
        return new PrimaryLog(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryLog {
        let vals = path?.split('/');
        return new PrimaryLog(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryLog[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Log): string {
    let fields = entity ? [
    entity.timberKey,
            entity.externalKey,
            entity.internalKey,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityLog {
    id: PrimaryLog;
    data: UpdateLog;


    constructor(id: PrimaryLog, data: UpdateLog) {
        this.id = id;
        this.data = data;
    }
}
